import { Address } from '@src/types/token'

export const EVM_PROD_WALLET = '0x451F52446EBD4376d4a05f4267eF1a03Acf1aAf4' as Address

export const SOLANA_PUBLICKEY_PROD = 'CsdzNkjhFh52VJDcieF7iQvw4xe37zDo1D1WSmDDi3CG' as Address

export const TRON_PROD_WALLET = 'TQfuz6FEYBmt8VVNnoJeRR3UyqC1HQuP9m' as Address
